const inActivityData = {
  viewClick: [
    { k: '页面访问PV' },
    { k: '页面访问UV' },
    { k: '点击次数' },
    { k: '点击人数' },
    { k: '人均浏览量' },
    { k: 'UV跳失率' },
    { k: '引流商详PV' },
    { k: '引流商详UV' },
    { k: '商详到达率' },
    {},
  ],
  rebuyInfo: [],
  dealTrans: [{ k: '成交订单数' }, { k: '成交订单金额' }, { k: '成交商品数' }, { k: '成交转化率' }],
  flowEfficiency: [{ k: '客单价' }, { k: 'UV价值' }, { k: '次日复访率' }],
};

const inSourceData = {
  rebuyInfo: [],
  viewClick: [
    { k: '曝光PV' },
    { k: '曝光UV' },
    { k: '点击次数' },
    { k: '点击人数' },
    { k: '引流商详UV' },
    { k: '商详到达率' },
  ],
  dealTrans: [{ k: '引入订单数' }, { k: '引入订单转化率' }],
  flowEfficiency: [{ k: '次日留存UV' }, { k: '7日留存UV' }, { k: '次日复访率' }, { k: '7日复访率' }],
};

export default {
  inActivityData,
  inSourceData,
};
